/**
 * @fileoverview A function that renders the study routes.
 *
 * @example
 * renderStudiesRoutes()
 */

import { Navigate, Route } from 'react-router-dom'
import { StudyCard } from '../components/admin/StudyCard'
import { StudyList } from '../components/admin/StudyList'
import { ParticipantTab } from '../components/admin/tabs/Participants'
import { SitesTab } from '../components/admin/tabs/Sites'
import { TestingProtalTab } from '../components/admin/tabs/TestingPortal'
import { Layout } from '../components/Layout'

/**
 * @function renderStudiesRoutes
 * @description Renders the study routes.
 * @returns {React.ReactNode} - The study routes.
 */
export const renderStudiesRoutes = () => {
    return (
        <Route path="studies" element={<Layout />}>
            <Route index element={<StudyList />} />
            <Route path=":studyId" element={<StudyCard />}>
                <Route path="participants" element={<ParticipantTab />} />
                <Route path="sites" element={<SitesTab />} />
                <Route path="links" element={<TestingProtalTab />} />
                <Route index element={<Navigate to="participants" replace />} />
            </Route>
        </Route>
    )
}
